import { Component, OnInit } from '@angular/core';
import { faUser, faClock, faXmark, faLanguage, faCalendar, faMapMarkerAlt } from '@fortawesome/pro-regular-svg-icons';
import { TopazFilterItem } from '@pearsonvue/topaz-angular-ui';
import { SppdashboardService } from '../dashboard/sppdashboard.service';
import { TrainingSelectionModalComponent } from 'src/app/component/training-selection-modal/training-selection-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { distinctUntilChanged } from 'rxjs';

interface SessionCard {
  instructorName?: string;
  trainingName?: string;
  trainingTiming?: string;
  startDate?: Date;
  endDate?: Date;
  location?: string;
  timezone?: string;
  language?: string;
  id: string;
}

@Component({
  selector: 'app-iltsession-list',
  standalone: false,
  templateUrl: './iltsession-list.component.html',
  styleUrl: './iltsession-list.component.scss'
})
export class ILTSessionListComponent implements OnInit {


  public countryData: TopazFilterItem[] = [];
  public selectedCountryFilter: TopazFilterItem[] = [];
  public selectedCountryNames: string[] = [];
  public selectedTimeZoneFilter: TopazFilterItem[] = [];
  public timeZoneData: TopazFilterItem[] = [];
  loggedUserDetails: any = {};
  public status : string = '';
  public previousStatus: string = '';
  isHomeBtn: boolean = false;



  public icons = {
    faClock,
    faUser,
    faXmark,
    faLanguage,
    faCalendar,
    faMapMarkerAlt,
  };
  public selectedSessionId = '';
  public sessionCards: SessionCard[] = [];
  public isLoading = false;
  public totalElementsinDb = 0;

  private readonly pageSize = 20;
  private currentPage = 1;
  private hasMorePages = true;
  private readonly scrollThresholdPx = 80;
  baseCountry: string = '';


  public dialogConfig: any;
  public dialog!: MatDialogRef<TrainingSelectionModalComponent>;

  constructor(private _spp: SppdashboardService, private dialogModel: MatDialog, private router: Router, private _auth: AuthService) { }

  ngOnInit(): void {
       this._auth.getLoggedInUserDetails()
          .pipe(distinctUntilChanged((prev: any, curr: any) => JSON.stringify(prev) === JSON.stringify(curr)))
          .subscribe((res: any) => {
            if (res) {
              this.loggedUserDetails = res;
              const status = this.loggedUserDetails?.status || '';
              const previousStatus = this.loggedUserDetails?.previousStatus || '';
              this.isHomeBtn = (previousStatus === 'RENEWAL' && (status === 'TEST_OUT_FAIL' || status === 'ILT_FAIL')) ? true : false;
              this.baseCountry = this.loggedUserDetails?.country ? this.loggedUserDetails.country : '';
              this.getILTSessionList(false);
            }
      });

    // TODO: -  Needed those function call if Filter functionality is required in future. For now, we are not using any filter functionality.
    // this.getCountryList();
    // this.getTimeZoneList();
  }


  applyTimeZoneFilter(changed: TopazFilterItem[]) {
    this.selectedTimeZoneFilter = Array.isArray(changed) ? changed : [];
    this.getILTSessionList(false);
  }

  getTimeZoneList = () => {
    this._spp.getTimeZoneList(this.selectedCountryNames || [], this.baseCountry).subscribe({
      next: (response: any) => {
        this.timeZoneData = (Array.isArray(response) ? response : response?.data || [])
          .filter((item: any) => item?.displayName && item?.timeZone)
          .map((item: any) => ({
            name: item.displayName + ' (GMT ' + item.utcOffset + ')',
            value: {
              id: item.displayName + ' (GMT ' + item.utcOffset + ')'
            }
          }));
      },
      error: (error: any) => {
        console.error('Error fetching Time Zone List', error);
      }
    })
  }

  getCountryList = () => {
    this._spp.getCountriesForUserCountryTier(this.baseCountry).subscribe((response: any) => {
      const countryItems = response;
      this.countryData = countryItems
        .filter((item: any) => item?.countryName && item?.countryCode)
        .map((item: any) => ({
          name: item.countryName,
          value: {
            id: item.countryName
          }
        }));
    }, (error: any) => {
      console.error('Error fetching Country List', error);
    });
  }

  applyCountryFilter(changed: TopazFilterItem[]) {
    this.selectedCountryFilter = Array.isArray(changed) ? changed : [];
    this.selectedCountryNames = this.extractCountryNames(this.selectedCountryFilter);
    this.getTimeZoneList();
    this.selectedTimeZoneFilter = [];
    this.getILTSessionList(false);
  }

  private extractCountryNames(filters: TopazFilterItem[]): string[] {
    return filters.map(filter => filter.name);
  }

  public removeTimeZoneFilterItem(item: TopazFilterItem): void {
    this.selectedTimeZoneFilter = this.selectedTimeZoneFilter.filter((value) => value.name !== item.name);
    this.getILTSessionList(false);
  }


  removeCountryFilterItem(item: TopazFilterItem): void {
    this.selectedCountryFilter = this.selectedCountryFilter.filter((value) => value.name !== item.name);
    this.selectedCountryNames = this.extractCountryNames(this.selectedCountryFilter);
    this.selectedTimeZoneFilter = [];
    this.getTimeZoneList();
    this.getILTSessionList(false);
  }

  getILTSessionList = (append = false) => {
    if (this.isLoading || (!this.hasMorePages && append)) {
      return;
    }

    if (!append) {
      this.currentPage = 1;
      this.hasMorePages = true;
      this.sessionCards = [];
    }

    this.isLoading = true;
    const selectedCountries = this.toCommaSeparatedFilterString(this.selectedCountryFilter);
    const selectedTimeZones = this.toCommaSeparatedFilterString(this.selectedTimeZoneFilter) || this.loggedUserDetails?.timeZone;
    const pageIndex = this.currentPage - 1; // API is 0-based

    this._spp.getInstructors(this.baseCountry, selectedCountries, selectedTimeZones, pageIndex, this.pageSize).subscribe({
      next: (response: any) => {
        const newItems: SessionCard[] = Array.isArray(response?.content) ? response.content : [];
        this.sessionCards = append ? [...this.sessionCards, ...newItems] : newItems;

        this.hasMorePages = this.resolveHasMorePages(response, newItems.length);
        if (this.hasMorePages) {
          this.currentPage += 1;
        }

        this.isLoading = false;
      },
      error: (error: any) => {
        console.error("Error fetching ILT session list:", error);
        this.hasMorePages = false;
        this.isLoading = false;
      }
    });
  }

  private toCommaSeparatedFilterString(filters: TopazFilterItem[]): string {
    return (Array.isArray(filters) ? filters : [])
      .map((item: TopazFilterItem) => {
        const idValue = (item?.value as { id?: string } | undefined)?.id;
        return (typeof idValue === 'string' && idValue.trim()) || item?.name || '';
      })
      .filter((value: string) => !!value)
      .join(',');
  }

  public onCardWrapperScroll(event: Event): void {
    const target = event.target as HTMLElement | null;
    if (!target || this.isLoading || !this.hasMorePages) {
      return;
    }

    const distanceToBottom = target.scrollHeight - target.scrollTop - target.clientHeight;
    if (distanceToBottom <= this.scrollThresholdPx) {
      this.getILTSessionList(true);
    }
  }

  public selectSession(sessionId: string): void {
    this.selectedSessionId = sessionId;
    const selectedCard = this.sessionCards.filter((value) => value.id === sessionId);
    this.dialogConfig = {
      data: selectedCard[0]
    };

    this.dialog = this.dialogModel.open(TrainingSelectionModalComponent, { data: this.dialogConfig });

    this.dialog.afterClosed().subscribe({
      next: (result) => {
        if (result) {
          // Handle the result from the dialog here (e.g., update the UI, make API calls, etc.)
          if (result === 'continue') {
            // User clicked "Continue" in the dialog, perform the desired action here
            this.enrollUserForSession(this.selectedSessionId);
          }
        } else {
          console.log('Dialog was closed without a result');
        }
      },

      error: (error) => {
        console.error('Error in dialog:', error);
      },
      complete: () => {
        console.log('Dialog closed');
      }
    });
  }


  enrollUserForSession(sessionId: string): void {    
    this._spp.enrollUserForILTSession(sessionId, this.loggedUserDetails.userid).subscribe({
      next: (response) => {
        // After successful enrollment, navigate to the payment page for the selected session
        this.paymentForSelectedSession(this.selectedSessionId);
      },
      error: (error) => {
        console.error('Error enrolling user for session:', error);
      }
    });

  }


  paymentForSelectedSession(sessionId: string): void {
    this.router.navigate(['/live']);
  }

  private resolveHasMorePages(response: any, currentBatchCount: number): boolean {
    const totalPages = response?.totalPages;
    if (typeof totalPages === 'number' && totalPages > 0) {
      return this.currentPage < totalPages;
    }

    if (typeof response?.last === 'boolean') {
      return !response.last;
    }

    return currentBatchCount >= this.pageSize;
  }

  // Getter to check if any filters are selected
  get hasSelectedFilters(): boolean {
    return this.selectedCountryFilter && this.selectedCountryFilter.length > 0;
  }
}
